import { EVICT_BLACKLIST_CACHE, FETCH_BLACKLIST_SUCCESS, SET_BLACKLIST_LOADING } from './blacklistType';

const initialState = {
  blacklistedInfluencer: {},
  count: 0,
  isLoading: false,
};

const blacklistReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_BLACKLIST_LOADING:
      return { ...state, isLoading: action.payload };
    case FETCH_BLACKLIST_SUCCESS:
      return {
        ...state,
        blacklistedInfluencer: { ...state.blacklistedInfluencer, [action.payload.key]: action.payload.influencer },
        count: action.payload.count,
      };
    case EVICT_BLACKLIST_CACHE:
      return {
        ...state,
        blacklistedInfluencer: {},
        count: 0,
        isLoading: false,
      };
    default:
      return { ...state };
  }
};

export default blacklistReducer;
